import { authClient } from '@/lib/auth-client'

// Variables que se reemplazan al insertar una plantilla en el composer. Si un
// valor no está disponible el token se deja tal cual, visible en el mensaje,
// para que quien envía lo note y lo complete a mano.
export const TEMPLATE_VARIABLES = [
  { token: 'nombre', hint: 'Primer nombre del destinatario' },
  { token: 'nombre_completo', hint: 'Nombre completo del destinatario' },
  { token: 'sucursal', hint: 'Sucursal activa' },
  // Solo tienen valor al enviar un comprobante; en otros envíos el token queda
  // a la vista para que quien escribe note que ahí no aplica.
  { token: 'numero', hint: 'Número del comprobante (solo al enviar una factura)' },
  { token: 'total', hint: 'Total del comprobante (solo al enviar una factura)' },
  { token: 'fecha', hint: 'Fecha de emisión (solo al enviar una factura)' },
] as const

export type TemplateValues = Partial<Record<(typeof TEMPLATE_VARIABLES)[number]['token'], string>>

export function fillTemplate(text: string, values: TemplateValues): string {
  return text.replace(/\{\{\s*([a-zA-Z_]+)\s*\}\}/g, (token, name: string) => {
    const value = values[name.toLowerCase() as keyof TemplateValues]
    return value?.trim() ? value : token
  })
}

// El nombre de la sucursal activa (Better Auth organization) para {{sucursal}}.
export function useBranchName(): string | undefined {
  const activeOrg = (authClient as any).useActiveOrganization?.() as
    | { data: { name?: string } | null | undefined }
    | undefined
  return activeOrg?.data?.name
}
